import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";
import SectionTitle from "@/components/base/SectionTitle";
import { formatCount, formatShortDate, getHotArticles, themeOf } from "@/utils/content";

export default function HotBoard() {
  const featured = articles.find((item) => item.featured) || articles[0];
  const hot = getHotArticles(5).filter((item) => item.id !== featured.id);
  const theme = themeOf(featured.category);

  return (
    <section id="hot" className="w-full scroll-mt-20 bg-secondary-50 py-14 md:py-20">
      <div className="mx-auto max-w-6xl px-4 md:px-8">
        <SectionTitle
          eyebrow="热门内容推荐"
          title="这两天被反复讨论的几条"
          description="根据阅读与互动热度整理，热度不代表事实认定，请带着自己的判断阅读。"
          actionLabel="看全部热门"
          actionTo="/category/all"
        />

        <div className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-3">
          <article className="group overflow-hidden rounded-lg border border-background-200 bg-background-50 lg:col-span-2">
            <Link to={`/article/${featured.id}`} className="block">
              <div className="relative h-64 w-full overflow-hidden md:h-80">
                <img
                  src={featured.cover}
                  alt={featured.title}
                  title={`${featured.title} - 511爆料`}
                  className="h-full w-full object-top object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-4 top-4 inline-flex items-center gap-1 rounded-md bg-primary-500 px-2.5 py-1 text-xs font-semibold text-background-50">
                  <i className="ri-fire-line" />
                  编辑推荐
                </span>
              </div>
              <div className="p-6">
                <span className={`inline-flex items-center gap-1 rounded px-2 py-0.5 text-xs font-semibold ${theme.chip}`}>
                  {featured.categoryName}
                </span>
                <h3 className="mt-3 font-heading text-xl font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-600 md:text-2xl">
                  {featured.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-foreground-600">{featured.summary}</p>
                <div className="mt-5 flex flex-wrap items-center gap-4 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-user-3-line" />
                    {featured.author}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line" />
                    {formatShortDate(featured.date)}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line" />
                    {formatCount(featured.views)}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-heart-3-line" />
                    {formatCount(featured.likes)}
                  </span>
                </div>
              </div>
            </Link>
          </article>

          <div className="rounded-lg border border-background-200 bg-background-50 p-5">
            <h3 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
              <i className="ri-bar-chart-2-line text-primary-500" />
              热度榜单
            </h3>
            <ol className="mt-4 flex flex-col gap-1">
              {hot.map((item, index) => {
                const itemTheme = themeOf(item.category);
                return (
                  <li key={item.id}>
                    <Link
                      to={`/article/${item.id}`}
                      className="group flex items-start gap-3 rounded-lg p-2 transition-colors hover:bg-background-100"
                    >
                      <span
                        className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-md text-xs font-bold ${
                          index < 2 ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-700"
                        }`}
                      >
                        {index + 1}
                      </span>
                      <span className="min-w-0">
                        <span className="line-clamp-2 block text-sm font-semibold leading-snug text-foreground-900 transition-colors group-hover:text-primary-600">
                          {item.title}
                        </span>
                        <span className="mt-1 flex items-center gap-2 text-xs text-foreground-500">
                          <span className={`rounded px-1.5 py-0.5 ${itemTheme.chip}`}>{item.categoryName}</span>
                          {formatCount(item.views)} 阅读
                        </span>
                      </span>
                    </Link>
                  </li>
                );
              })}
            </ol>
            <Link
              to="/category/all"
              className="mt-4 flex items-center justify-center gap-1 rounded-md border border-background-300 py-2.5 text-sm font-semibold text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600"
            >
              查看更多热门
              <i className="ri-arrow-right-line" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}